import { HRM_PERMISSIONS } from './permissions';

const P = HRM_PERMISSIONS;

/**
 * Who may open a setup/catalog page (sidebar item and route): anyone holding at least one of its
 * write permissions. Reading these records for dropdowns elsewhere in the app is governed by the
 * data rules, so a user who only needs the list in a form never sees the manager page.
 */
export const HRM_MANAGE_PERMISSIONS = {
  DEPARTMENT: [
    P.SETTINGS.DEPARTMENTS_CREATE,
    P.SETTINGS.DEPARTMENTS_UPDATE,
    P.SETTINGS.DEPARTMENTS_DELETE,
  ],
  ROLE: [P.SETTINGS.ROLES_CREATE, P.SETTINGS.ROLES_UPDATE, P.SETTINGS.ROLES_DELETE],
  DESIGNATION: [P.SETTINGS.DESIGNATIONS_CREATE, P.SETTINGS.DESIGNATIONS_UPDATE],
  LOCATION: [P.SETTINGS.LOCATIONS_CREATE, P.SETTINGS.LOCATIONS_UPDATE, P.SETTINGS.LOCATIONS_DELETE],
  PROJECT: [P.SETTINGS.PROJECTS_CREATE, P.SETTINGS.PROJECTS_UPDATE, P.SETTINGS.PROJECTS_DELETE],
  SKILL_CATEGORY: [
    P.SETTINGS.SKILL_CATEGORIES_CREATE,
    P.SETTINGS.SKILL_CATEGORIES_UPDATE,
    P.SETTINGS.SKILL_CATEGORIES_DELETE,
  ],
  SKILL_SUB_CATEGORY: [
    P.SETTINGS.SKILL_SUB_CATEGORIES_CREATE,
    P.SETTINGS.SKILL_SUB_CATEGORIES_UPDATE,
    P.SETTINGS.SKILL_SUB_CATEGORIES_DELETE,
  ],
  SKILL: [P.SETTINGS.SKILLS_CREATE, P.SETTINGS.SKILLS_UPDATE],
  NOC_TYPE: [P.SETTINGS.NOC_TYPES_CREATE, P.SETTINGS.NOC_TYPES_UPDATE, P.SETTINGS.NOC_TYPES_DELETE],
  CTC_LEVEL: [
    P.SETTINGS.CTC_LEVELS_CREATE,
    P.SETTINGS.CTC_LEVELS_UPDATE,
    P.SETTINGS.CTC_LEVELS_DELETE,
  ],
  LEAVE_CATEGORY: [
    P.SETTINGS.LEAVE_POLICIES_CREATE,
    P.SETTINGS.LEAVE_POLICIES_UPDATE,
    P.SETTINGS.LEAVE_POLICIES_DELETE,
  ],
  HOLIDAY: [
    P.SETTINGS.HOLIDAYS_VIEW_LIST,
    P.SETTINGS.HOLIDAYS_CREATE,
    P.SETTINGS.HOLIDAYS_UPDATE,
    P.SETTINGS.HOLIDAYS_DELETE,
    P.SETTINGS.HOLIDAYS_MARK_CANTON_BASED,
  ],
  MBM_PROJECT: [P.SETTINGS.MBM_PROJECTS_CREATE, P.SETTINGS.MBM_PROJECTS_UPDATE],
  PERFORMANCE_FORM: [
    P.SETTINGS.REVIEW_TEMPLATES_CREATE,
    P.SETTINGS.REVIEW_TEMPLATES_UPDATE,
    P.SETTINGS.REVIEW_TEMPLATES_DELETE,
  ],
  SURVEY_FORM: [
    P.SETTINGS.SURVEY_FORMS_CREATE,
    P.SETTINGS.SURVEY_FORMS_UPDATE,
    P.SETTINGS.SURVEY_FORMS_DELETE,
  ],
} satisfies Record<string, string[]>;

/** The Skill Manager holds three catalogs, one tab each: it opens for whoever may manage any of them. */
export const SKILL_MANAGER_PERMISSIONS = [
  ...HRM_MANAGE_PERMISSIONS.SKILL_CATEGORY,
  ...HRM_MANAGE_PERMISSIONS.SKILL_SUB_CATEGORY,
  ...HRM_MANAGE_PERMISSIONS.SKILL,
];

/** Each tab of Service Requests has its own page permission; any of them opens the page. */
export const SERVICE_REQUEST_PAGE_PERMISSIONS = [
  P.SERVICE_REQUEST.VIEW_OWN,
  P.SERVICE_REQUEST.VIEW_TEAM,
  P.SERVICE_REQUEST.VIEW_ALL,
];
